var GPay_TransactionState;
(function(GPay_TransactionState) {
    GPay_TransactionState["SUCCESS"] = "SUCCESS";
    GPay_TransactionState["ERROR"] = "ERROR";
})(GPay_TransactionState || (GPay_TransactionState = {}));
const allowedCardNetworks = [
    'AMEX',
    'DISCOVER',
    'INTERAC',
    'JCB',
    'MASTERCARD',
    'MAESTRO',
    'VISA', 
];

export { GPay_TransactionState, allowedCardNetworks };
//# sourceMappingURL=types.js.map
